import { ElasticCourseData, ElasticRoundAnalytics, TournamentEventTypeEnum } from '@spikemark/rest-api';
import { createContext, FC, PropsWithChildren, useCallback, useContext, useMemo, useState } from 'react';
import { ScorecardDialog } from './scorecard-dialog';
type ScorecardDialogProviderProps = {
  data: ElasticRoundAnalytics[];
  format: TournamentEventTypeEnum;
  courseInfoMap: Record<string, ElasticCourseData>;
  playerRankingsDisplayCutoff?: number;
  suppressProfileLinks?: boolean;
};
type ScorecardDialogContextType = {
  showPlayerScorecard: (playerId: string) => void;
  hidePlayerScorecard: () => void;
};
const ScorecardDialogContext = createContext<ScorecardDialogContextType>({} as ScorecardDialogContextType);
export const ScorecardDialogProvider: FC<PropsWithChildren<ScorecardDialogProviderProps>> = ({
  children,
  data,
  format,
  playerRankingsDisplayCutoff,
  courseInfoMap,
  suppressProfileLinks
}) => {
  const [activePlayerId, setActivePlayerId] = useState<string | null>(null);
  const [isActive, setIsActive] = useState(false);
  const showPlayerScorecard = useCallback((playerId: string) => {
    setActivePlayerId(playerId);
    setIsActive(true);
  }, []);
  const hidePlayerScorecard = useCallback(() => {
    setIsActive(false);
  }, []);
  const activePlayerData = useMemo(() => data.find(x => x.playerId === activePlayerId), [data, activePlayerId]);
  const value = useMemo(() => ({
    showPlayerScorecard,
    hidePlayerScorecard
  }), [showPlayerScorecard, hidePlayerScorecard]);
  return <ScorecardDialogContext.Provider value={value} data-sentry-element="unknown" data-sentry-component="ScorecardDialogProvider" data-sentry-source-file="scorecard-dialog-provider.tsx">
      {children}
      {activePlayerData && <ScorecardDialog data={activePlayerData} format={format} playerRankingsDisplayCutoff={playerRankingsDisplayCutoff} isOpen={isActive} courseInfoMap={courseInfoMap} suppressProfileLinks={suppressProfileLinks} onClose={() => setIsActive(false)} />}
    </ScorecardDialogContext.Provider>;
};
export const useScorecardDialogContext = () => useContext(ScorecardDialogContext);